import { http } from "@/http/axios.js";
import axios from "axios";
import { getToken } from "@/utils/auth";
import { showScreenLoading, hideScreenLoading } from "@/http/loading.js";
import { dateFormat } from "@/utils/index.js";

/** 联营订单分页 */
export function getJointOrderPageAPI(params) {
  return http({
    url: "/admin/store/joint/order/page",
    method: "get",
    params,
  });
}

/** 联营订单-分账明细 */
export function getJointOrderRoyaltyDetailAPI(params) {
  return http({
    url: "/admin/store/joint/order/royalty/detail",
    method: "get",
    params,
  });
}

/** 联营订单导出 */
export function exportJointOrderAPI(data) {
  showScreenLoading();
  return axios({
    method: "post",
    url: "/api/admin/store/joint/order/export",
    responseType: "blob",
    data,
    headers: {
      Authorization: getToken() || "",
    },
  })
    .then((res) => {
      hideScreenLoading();
      const blob = res.data;
      const url = window.URL.createObjectURL(new Blob([blob]));
      const a = document.createElement("a");
      a.style.display = "none";
      a.href = url;
      const filename = `联营订单${dateFormat()}.xlsx`;
      a.setAttribute("download", decodeURIComponent(filename));
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(a.href);
      document.body.removeChild(a);
    })
    .catch(() => {
      hideScreenLoading();
    });
}
